module.exports = __webpack_public_path__ + "img/logo.de6c2627.jpg";